import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxAimService } from '../../../../ngx-aim.service';
import { AppLazyLoadEvent, FindAllResult, SaveStrDateTimeDto, ShortTermRentalDateTime } from '../../../../models';
import { Observable } from 'rxjs';
import { GenericSearchService, HttpErrorService } from '../../../../services';

@Injectable({
  providedIn: 'root'
})
export class NgxAimAdminStrTimeSlotsService extends GenericSearchService<ShortTermRentalDateTime> {
  private baseUrl = `${this.ngxAimService.getApiUrl()}/admin/str-date-time`;

  constructor(
    private http: HttpClient,
    private ngxAimService: NgxAimService,
    private _httpErrorService: HttpErrorService,
  ) {
    super(_httpErrorService, 'STR Time Slots');
  }

  findAll(dto: AppLazyLoadEvent): Observable<FindAllResult<ShortTermRentalDateTime>> {
    return this.http.post<FindAllResult<ShortTermRentalDateTime>>(`${this.baseUrl}/all`, dto);
  }

  findOne(id: number): Observable<ShortTermRentalDateTime> {
    return this.http.get<ShortTermRentalDateTime>(`${this.baseUrl}/post/${id}`);
  }

  save(dto: SaveStrDateTimeDto): Observable<HttpEvent<ShortTermRentalDateTime>> {
    return this.http.post<ShortTermRentalDateTime>(this.baseUrl, dto, {
      reportProgress: true,
      observe: 'events',
    });
  }

  toggleEnabled(timeSlot: ShortTermRentalDateTime) {
    return this.http.post<void>(`${this.baseUrl}/toggle-enabled`, timeSlot);
  }
}
